module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-awesome/fontawesome-webfont.eot?v=4.7.0
// module id = ../../../../../src/assets/fonts/font-awesome/fontawesome-webfont.eot?v=4.7.0
// module chunks = 40